const exceptions = [];

let routes = [
  {
    name: "统计看板",
    path: "/statistical",
    component: () => import("@/views/dashboard/statistics/index.vue"),
    meta: {
      icon: "icon-tongjikanban",
      perm: "statistical",
    },
  },
  //房源平台
  // {
  //   name: "首页",
  //   path: "/statistical/manager",
  //   component: () => import("@/views/baseInfo/order/index"),
  //   meta: {
  //     icon: "icon-dingdan",
  //     perm: "statistical",
  //   },
  // },
  {
    name: "首页-管理员",
    path: "/statistical/admin",
    component: () => import("@/views/home/admin"),
    meta: {
      icon: "icon-dingdan",
      perm: "stat_admin",
    },
  },
  {
    name: "首页",
    path: "/statistical/manager",
    component: () => import("@/views/home/manager"),
    meta: {
      icon: "icon-dingdan",
      perm: "stat_manager",
    },
  },
  //房源管理 fangyuanguanli
  {
    name: "房源信息",
    path: "/roomInfo",
    component: () => import("@/views/baseInfo/room"),
    meta: {
      icon: "icon-fangyuanxinxi",
      perm: "roomInfo",
    },
  },

  {
    name: "经营者信息",
    path: "/managerInfo",
    component: () => import("@/views/baseInfo/manager/index"),
    meta: {
      icon: "icon-jingyingzhe",
      perm: "managerInfo",
    },
  },
  {
    name: "个人中心",
    path: "/personal",
    component: () => import("@/views/personal/index.vue"),
    meta: {
      icon: "icon-personal",
      perm: "personal",
    },
  },
  {
    name: "从业人员信息",
    path: "/config/employee",
    component: () => import("@/views/baseInfo/employee/index"),
    meta: {
      icon: "icon-congyerenyuan",
      perm: "baseInfo_employee",
    },
  },
  //订单管理 dingdanguanlix
  {
    name: "订单信息",
    path: "/orderInfo",
    component: () => import("@/views/baseInfo/order/index"),
    meta: {
      icon: "icon-dingdan",
      perm: "orderInfo",
    },
  },
  {
    name: "房态",
    path: "/roomStatus",
    component: () => import("@/views/roomStatus/future/index.vue"),
    meta: {
      icon: "icon-roomStatus",
      perm: "roomStatus",
    },
  },
  {
    name: "入住信息",
    path: "/checkInPersonInfo",
    component: () => import("@/views/orderManage/checkInPersonInfo"),
    meta: {
      icon: "icon-ruzhuxinxi",
      perm: "checkInPersonInfo",
    },
  },

  // 设备管理
  {
    name: "智能门锁",
    path: "/equip/doorLock",
    component: () => import("@/views/equip/doorLock/index"),
    meta: {
      icon: "icon-zhinengmensuo",
      perm: "lockInfo", // 这项设置必须和后端接口返回的一致，否则菜单跳转失败
    },
  },
  {
    name: "智能门铃",
    path: "/equip/doorBell",
    component: () => import("@/views/equip/doorBell/index"),
    meta: {
      icon: "icon-zhinengmenling",
      perm: "doorBellInfo",
    },
  },
  {
    name: "租客",
    path: "/tenant",
    component: () => import("@/views/tenant/index")
  },
  {
    name: "访客",
    path: "/visitor",
    component: () => import("@/views/visitor/index"),
    meta: {
      perm: "baseInfo_visitor",
    },
  },

  {
    name: "保洁成员",
    path: "/clean/cleanerManage",
    component: () => import("@/views/clean/cleanerManage/index"),
    meta: {
      perm: 'staffInfo'
    }
  },

  {
    name: "保洁任务",
    path: "/clean/task",
    component: () => import("@/views/clean/task/index"),
    meta: {
      perm: 'staffTaskInfo'
    }
  },

  //采集日志
  {
    name: "门锁日志",
    path: "/gateLockLog",
    component: () => import("@/views/equipLog/logPage"),
    meta: {
      icon: "icon-mensuorizhi",
      perm: "gateLockLog",
    },
  },
  {
    name: "门铃日志",
    path: "/gateBellLog",
    component: () => import("@/views/equipLog/bellLogPage"),
    meta: {
      icon: "icon-menlingrizhi",
      perm: "gateBellLog",
    },
  },
  {
    name: "固件管理",
    path: "/firmwareManager",
    component: () => import("@/views/configAndUpgrade/hardwareManage"),
    meta: {
      icon: "icon-menlingrizhi",
      perm: "firmwareManager",
    },
  },
  {
    name: "下发日志",
    path: "/issuedLog",
    component: () => import("@/views/configAndUpgrade/issuedLog"),
    meta: {
      icon: "icon-menlingrizhi",
      perm: "issuedLog",
    },
  },
  {
    name: "设备授权名单",
    path: "/equip/whiteList",
    component: () => import("@/views/equip/authList"),
    meta: {
      icon: "icon-baimingdan",
      perm: "whiteList",
    },
  },
  {
    name: "设备未授权名单",
    path: "/equip/blackList",
    component: () => import("@/views/equip/unauthList"),
    meta: {
      icon: "icon-heimingdan",
      perm: "blackList",
    },
  },

  // 系统管理-常用信息
  {
    name: "数据推送配置",
    path: "/system/dataPush",
    component: () => import("@/views/system/dataPush/index"),
    meta: {
      icon: "icon-menlingrizhi",
      perm: "dataPush",
    },
  },
  {
    name: "数据推送日志",
    path: "/system/pushDataLog",
    component: () => import("@/views/system/dataPush/pushLog"),
    meta: {
      icon: "icon-menlingrizhi",
      perm: "pushDataLog",
    },
  },
  {
    name: "检查项配置",
    path: "/spy/checkItem/manage",
    component: () => import("@/views/system/checkItem/manage"),
    meta: {
      icon: "icon-menlingrizhi",
      perm: "check_item_manage",
    },
  },
  {
    name: "参数配置",
    path: "/system/advance/systemParams",
    component: () => import("@/views/system/advance/systemParams"),
    meta: {
      icon: "icon-xitongpeizhi",
      perm: "system_advance_param",
    },
  },
  {
    name: "用户管理",
    path: "/system/common/users/index",
    component: () => import("@/views/system/common/users/usersIndex"),
    meta: {
      icon: "icon-yonghuguanli",
      perm: "system_general_user",
    },
  },
  {
    name: "角色管理",
    path: "/system/common/roles",
    component: () => import("@/views/system/common/roles/rolesIndex"),
    meta: {
      icon: "icon-jiaoseguanli",
      perm: "system_general_role",
    },
  },
  {
    name: "菜单管理",
    path: "/system/common/menuMng",
    component: () => import("@/views/system/common/menuMng"),
    meta: {
      icon: "icon-putongneirong",
      perm: "system_general_menu",
    },
  },
  {
    name: "部门管理",
    path: "/system/common/deptMng",
    component: () => import("@/views/system/common/deptMng"),
    meta: {
      icon: "icon-bumenguanli",
      perm: "system_general_dept",
    },
  },
  {
    name: "字典管理",
    path: "/system/common/dictMng",
    component: () => import("@/views/system/common/dictMng"),
    meta: {
      icon: "icon-zidianguanli",
      perm: "system_general_dict",
    },
  },
  {
    name: "操作日志",
    path: "/system/log/operateLog",
    component: () => import("@/views/system/log/operateLog"),
    meta: {
      icon: "icon-caozuorizhi",
      perm: "operateLog",
    },
  },
  {
    name: "异常监控",
    path: "/dataPushMoniter",
    component: () => import("@/views/system/advance/dataPushMoniter"),
    meta: {
      icon: "icon-yichanggaojing",
      perm: "dataPushMoniter",
    },
  },
  {
    name: "异常告警",
    path: "/alarmInfo",
    component: () => import("@/views/alarm/alarm"),
    meta: {
      icon: "icon-yichanggaojing",
      perm: "alarmInfo",
    },
  },
  {
    name: "审核配置",
    path: "/system/auditConfig",
    component: () => import("@/views/system/auditConfig"),
    meta: {
      icon: "icon-shenhepeizhi",
      perm: "auditConfig",
    },
  },
  {
    name: '门店管理',
    path: '/shop/shopManage',
    component: () => import('@/views/shop/shopManage')
  },
  {
    name: '收款账号设置',
    path: '/config/serviceFee/receiveAccount',
    component: () => import('@/views/expenses/accountSettings')
  },
  {
    name: '充值管理',
    path: '/config/serviceFee/rechargeManager',
    component: () => import('@/views/expenses/rechargeManagement')
  },
  {
    name: '消费账单',
    path: '/config/serviceFee/costBill',
    component: () => import('@/views/expenses/consumptionBills')
  },
  {
    name: '分配管家',
    path: '/housekeeper_distribution',
    perm: '/housekeeper_distribution',
    component: () => import('@/views/shop/shopManage/houseKeeperDistribution.vue'),
  },
  {
    name: '迁移房源',
    path: '/room_transfer',
    perm: "room_transfer",
    component: () => import('@/views/shop/shopManage/roomTransfer.vue'),
  },
  {
    name: '房型管理',
    path: '/roomtype_manage',
    perm: "roomtype_manage",
    component: () => import('@/views/shop/roomTypeManage')
  },
  {
    name: '排序管理',
    path: '/sorting',
    perm: "sorting",
    component: () => import('@/views/shop/roomTypeManage')
  },
  {
    name: 'OTA信息',
    path: '/OTA',
    perm: "ota",
    component: () => import('@/views/OTA/index.vue')
  },
];

const updateRoute = function (route, obj) {
  route.forEach((item) => {
    if (item.meta && item.meta.perm) {
      item.meta.auth = true;
      obj[item.meta.perm] = item;
    }
    if (item.children) {
      updateRoute(item.children, obj);
    }
  });
};

let routeOfPerms = {};
updateRoute(routes, routeOfPerms);

routes = routes.filter((item) => {
  return item.component && item.path;
});

export default {
  routes,
  routeOfPerms,
  exceptions,
};
